import { MotorsportsCalendarPageProps, MotorsportsCalendarPage } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CompetitionCalendarQuery } from "./types";

import transformQuery from "./transformers/query-transformer";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionCalendarQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<CompetitionCalendarQuery>): MotorsportsCalendarPageProps => {
  return transformQuery(props);
}

const GpCalendarContainer = ({
  props,
  ...rest
}: WidgetContext<MotorsportsCalendarPageProps>) => {
  log({ props, ...rest });

  return <MotorsportsCalendarPage {...props} />;
}

export default GpCalendarContainer;